module.exports = __webpack_public_path__ + "img/small-5.26622924.jpg";